import { registerPlugin } from '@capacitor/core';

export interface AnuraPlugin{
    performScan(options:{value:string}):Promise<{value:string}>;
}

const Anura = registerPlugin<AnuraPlugin>('Anura');
export default Anura;